<template>
    <div id="app">
        <v-app id="inspire">
            <v-parallax dark src="https://cdn.vuetifyjs.com/images/backgrounds/vbanner.jpg" height="250">
                <v-container>
                    <v-layout>
                        <h4 class="subheading font-weight-medium">SERVICES</h4>
                        <v-spacer></v-spacer>
                        <h4 class="subheading font-weight-medium">{{user.displayName}}</h4>
                    </v-layout>

                    <v-layout>
                        <v-container class="pr-0">
                            <v-flex xs6 right>
                            <v-text-field solo flat hide-details label="Search" v-model="search" append-icon="search" clearable ></v-text-field>
                            </v-flex>
                        </v-container>
                    </v-layout>
                    <br><br>
                    <v-spacer></v-spacer>
                    <v-flex xs6 right v-if="configuredServices.length > 0">
                        <v-btn color="red accent-4" dark @click="resetDialog=true">Sync<v-icon>sync</v-icon></v-btn>
                    </v-flex>
                    <v-flex xs6 right v-else>
                        <v-btn color="blue-grey" dark @click="fetchNetsuiteServices('setup')">GET SERVICES IN NETSUITE</v-btn>
                    </v-flex>
                </v-container>
            </v-parallax>

            <v-layout>
                <v-container>
                <v-flex xs12>
                    <br>
                    <v-data-table :search="search" :headers="headers" :items="configuredServices" class="elevation-1" :expand="expand" item-key="jobCode">
                        <template v-slot:items="props">
                            <td>{{ props.item.jobCode }}</td>
                            <td class="text-xs-left">{{ props.item.classification }}</td>
                            <td class="text-xs-left">{{ props.item.category }}</td>
                            <td class="text-xs-left">{{ props.item.name }}</td>
                            <td class="text-xs-left">{{ props.item.description }}</td>
                             <td class="text-xs-left">{{ props.item.price }}</td>
                            <!-- <td class="text-xs-left">
                                <v-edit-dialog :return-value.sync="props.item.displayName" large lazy persistent @save="saveConfig('displayName',props.item.displayName,props.item.jobCode)">
                                    <div>{{ props.item.displayName}}</div>
                                    <template v-slot:input>
                                        <div class="mt-3 title">Update Display Name</div>
                                    </template>
                                    <template v-slot:input>
                                        <v-text-field v-model="props.item.displayName" label="Display Name" single-line counter autofocus></v-text-field>
                                    </template>
                                </v-edit-dialog>
                            </td>
                            <td class="text-xs-left">
                                <v-edit-dialog :return-value.sync="props.item.displayDescription" large lazy persistent @save="saveConfig('displayDescription',props.item.displayDescription,props.item.jobCode)">
                                    <div>{{props.item.displayDescription}}</div>
                                    <template v-slot:input>
                                        <div class="mt-3 title">Update Display Description</div>
                                    </template>
                                    <template v-slot:input>
                                        <v-text-field v-model="props.item.displayDescription" label="Display Description" single-line counter autofocus></v-text-field>
                                    </template>
                                </v-edit-dialog>
                            </td>
                            <td class="text-xs-left">
                                <v-edit-dialog :return-value.sync="props.item.time" large lazy persistent  @save="saveConfig('time',props.item.time,props.item.jobCode)">
                                    <div>{{ props.item.time }}</div>
                                    <template v-slot:input>
                                        <div class="mt-3 title">Update Time</div>
                                    </template>
                                    <template v-slot:input>
                                        <v-select v-model="props.item.time" :items="timeRate" label="Time" single-line counter autofocus></v-select>
                                    </template>
                                </v-edit-dialog>
                            </td> -->
                            <!-- <td class="text-xs-left">
                                <v-btn small color="primary" dark @click="deployToBranch(props.item)">Assign</v-btn>
                            </td> -->
                        </template>

                        <template v-slot:no-data>
                            <v-alert :value="true" color="grey">
                                No Service Available
                            </v-alert>
                        </template>

                        <template v-slot:no-results>
                            <v-alert :value="true" color="error" icon="warning">
                                Your search for "{{ search }}" found no results.
                            </v-alert>
                        </template>
                    </v-data-table>
                </v-flex>

                
                </v-container>
            </v-layout>

            <v-layout row justify-center>
                <v-dialog v-model="showProgress" persistent width="300">
                    <v-card color="primary">
                        <v-card-text class="subheading white--text"> {{progressMessage}}
                            <v-layout row justify-center>
                            <v-progress-linear :indeterminate="true"
                                :size="70" :width="5" color="white"
                            ></v-progress-linear>
                            </v-layout>
                        </v-card-text>
                    </v-card>
                </v-dialog>

                <v-snackbar v-model="snackbar" bottom right :color="snackbarColor">{{ snackbarMessage }} 
                    <v-btn dark small flat @click="snackbar = false">Close</v-btn>
                </v-snackbar>

                <v-dialog v-model="resetDialog" max-width="500px">
                    <v-card>
                    <v-parallax dark src="https://cdn.vuetifyjs.com/images/backgrounds/vbanner.jpg" height="80">
                    <v-spacer></v-spacer>
                        <v-container>
                            <v-layout><br>
                            <h4 class="title font-weight-medium">Are you sure you want to reset the current list of services? </h4>
                            </v-layout>
                        </v-container>
                    </v-parallax>

                    <v-container grid-list>
                        <v-card-text class="subheading font-weight-regular">
                        You are about to reset the list of current services that will load the default data of services.
                        </v-card-text>
                        <v-card-text class="subheading font-weight-regular">
                        Do you want to proceed?
                        </v-card-text>

                        <v-card-actions class="justify-center">
                            <v-btn dark color="red accent-4" @click="resetDialog=false">NO</v-btn>
                            <v-btn dark color="blue darken-4" @click="(resetDialog=false),fetchNetsuiteServices('update')">YES</v-btn>
                        </v-card-actions>
                    </v-container>
                    </v-card>
                </v-dialog>

                <v-dialog v-model="showBranches" persistent>
                    <v-toolbar dark color="primary">
                        <v-btn icon dark @click="showBranches=false,selectedBranches.businessUnit=[]">
                        <v-icon>close</v-icon>
                        </v-btn>
                        <v-toolbar-title>Add Service to Branch</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items>
                        <v-btn dark flat @click="setBranchService()">Save</v-btn>
                        </v-toolbar-items>
                    </v-toolbar>
                    <v-card>
                        <v-container grid-list-md>
                        <v-layout wrap>
                            <v-flex xs4>
                                <v-card flat class="pt-5">
                                    <h4 class="subheading font-weight-medium grey--text">
                                        Job Code: <span class="subheading font-weight-medium black--text"> {{selectedService.jobCode}} </span>
                                    </h4>
                                    <h4 class="subheading font-weight-medium grey--text">
                                        Classification: <span class="subheading font-weight-medium black--text"> {{selectedService.classification}} </span>
                                    </h4>
                                    <h4 class="subheading font-weight-medium grey--text">
                                        Job Code: <span class="subheading font-weight-medium black--text"> {{selectedService.category}} </span>
                                    </h4>
                                    <h4 class="subheading font-weight-medium grey--text">
                                        Category: <span class="subheading font-weight-medium black--text"> {{selectedService.name}} </span>
                                    </h4>
                                    <h4 class="subheading font-weight-medium grey--text">
                                        Description: <span class="subheading font-weight-medium black--text"> {{selectedService.description}} </span>
                                    </h4>
                                    <h4 class="subheading font-weight-medium grey--text">
                                        Display Name: <span class="subheading font-weight-medium black--text"> {{selectedService.displayName}} </span>
                                    </h4>
                                    <h4 class="subheading font-weight-medium grey--text">
                                        Display Description: <span class="subheading font-weight-medium black--text"> {{selectedService.displayDescription}} </span>
                                    </h4>
                                    <h4 class="subheading font-weight-medium grey--text">
                                        Time Rate: <span class="subheading font-weight-medium black--text"> {{selectedService.time}} </span>
                                    </h4>
                                </v-card>
                            </v-flex>

                            <v-flex xs8 class="pr-0">
                                <v-layout wrap><v-spacer></v-spacer>
                                    <v-flex xs8>
                                        <v-text-field class="subheading font-weight-regular pb-3 pt-0" v-model="searchBranch" append-icon="search" label="Search" single-line hide-details></v-text-field>
                                    </v-flex>
                                </v-layout>
                                
                                <v-data-table :headers="branchHeaders"
                                :items="activeBranches" item-key="branchCode" :search="searchBranch" class="elevation-1" :pagination.sync="pagination">

                                    <template v-slot:items="props">
                                        <td class="text-xs-center">
                                            <v-checkbox v-model="selectedBranches.businessUnit" primary hide-details :value="props.item"></v-checkbox>
                                        </td>
                                        <td class="text-xs-center">{{ props.item.cluster }}</td>
                                        <td class="text-xs-center">{{ props.item.businessUnit }}</td>
                                    </template> 

                                    <template v-slot:no-data>
                                        <v-alert :value="true" color="grey">
                                            No Branch Available
                                        </v-alert>
                                    </template>

                                    <template v-slot:no-results>
                                        <v-alert :value="true" color="error" icon="warning">
                                            Your search for "{{ searchBranch }}" found no results.
                                        </v-alert>
                                    </template>
                                </v-data-table>
                            </v-flex> 
                        </v-layout>
                        </v-container>
                    </v-card>
                </v-dialog> 
            </v-layout>
        </v-app>
    </div>
</template>

<script>
import firebase from "firebase"
import firebaseui from "firebaseui"
import "../../node_modules/firebaseui/dist/firebaseui.css"
import { config } from "../firebaseConfig"
import router from '../router'
import { db } from '../main.js'
import { mapGetters, mapActions } from "vuex"
import store from '../stores'
import moment from 'moment'
import _ from 'lodash'
export default {
    data() {
        return {
            netsuiteServices: [],
            configuredServices: [],
            headers: [
                { text: 'Job Code', align: 'left', sortable: true, value: 'jobCode'},
                { text: 'Classification', value: 'classification',  sortable: true  },
                { text: 'Category', value: 'category',  sortable: true },
                { text: 'Name', value: 'name',  sortable: true  },
                { text: 'Description', value: 'description',  sortable: false },
                { text: 'Price', value: 'price',  sortable: false },
                // { text: 'Display Name', value: 'displayName',  sortable: false  },
                // { text: 'Display Description', value: 'displayDescription',  sortable: false },
                // { text: 'Time Rate(minutes)', value: 'timeRate',  sortable: false },
                // { text: 'Action', value: 'name',  sortable: false, align: 'center' },
            ],
            branchHeaders: [
                { text: 'Action', align: 'left', value: 'branchCode', },
                { text: 'Cluster', align: 'center', value: 'cluster',  sortable: true  },
                { text: 'Branch Name', align: 'center', sortable: true, value: 'businessUnit'},
            ],
            timeRate: [30,60,90,120,150,180,210,240,270,300,330,360,390],
            search: "",
            searchBranch: "",
            snackbar: false,
            snackbarColor: "",
            snackbarMessage: "",
            progressMessage: "",
            showProgress: false,
            progressMessage: "",
            dialog: false,
            resetDialog: false,
            expand: false,
            selectedService: {},
            activeBranches: [],
            showBranches: false,
            selectedBranches: {
                businessUnit: []
            },
            pagination: {},
        }
    },

    computed : {
        ...mapGetters(["user"]),
    },

    mounted() {
        this.fetchConfiguredServices()
        this.fetchBranches()   
    },

    methods: {
        async fetchBranches() {
            let self = this 
            self.activeBranches = []
            self.showProgress = true
            await db.collection("Branches"+self.$stage)
                .get().then(function(querySnapshots) {
                    querySnapshots.forEach(function(doc) {
                        self.activeBranches.push(doc.data())
                    })
                }).then(function(){
                    self.activeBranches = _.sortBy(self.activeBranches, o => o.cluster)
                }).catch(function(error) {
                    console.error("Error fetching document: ", error)
                    self.showProgress = false
                    self.snackbarColor = "error"
                    self.snackbarMessage = "Error fetching document"
                    self.snackbar = true
                })
        },

        fetchNetsuiteServices(type) {
            let self = this
            let countItems = 0
            let nonInventoryItems = []
            self.netsuiteServices = []
            self.showProgress = true
            self.progressMessage = "Fetching data from Netsuite..."
            self.$axios.defaults.headers.common['Authorization']=`NSJ ${self.$consumerKey}&${self.$consumerSecret}`
            self.$axios.defaults.headers.common['ns-token']= self.$tokenId
            self.$axios.defaults.headers.common['ns-token-secret']= self.$tokenSecret
            self.$axios.defaults.headers.common['Content-Type']= self.$contentType
            self.$axios.get(self.$itemMasterNonInventory).then(function(res){
                nonInventoryItems = res.data.data
            }).then(function() {
                nonInventoryItems.forEach(function(doc) {
                    if (doc.values.custitem_item_description.length > 0 && doc.values.custitem_item_industryclassification.length > 0) {
                        self.netsuiteServices.push(doc)
                    }
                    countItems ++
                })
                if(countItems === nonInventoryItems.length) {
                    if (type === "setup") {
                        self.clone(self.netsuiteServices)
                    } else {
                        self.syncAndUpdate(self.netsuiteServices)
                    } 
                }  
            }).catch(function(error) {
                console.error("Error fetching Netsuite document: ", error)
                self.showProgress = false
                self.snackbarColor = "error"
                self.snackbarMessage = "Error fetching Netsuite document"
                self.snackbar = true
            })
        },

        clone(result) {
            let self = this
            let countItems = 0
            result.forEach(function(doc) {
                db.collection("Services"+self.$stage).doc(doc.values.itemid).set({
                    jobCode: doc.values.itemid,
                    name: doc.values.displayname,
                    description: doc.values.custitem_item_description[0],
                    displayName: "",
                    displayDescription: "",
                    classification: doc.values.custitem_item_industryclassification[0],
                    category: doc.values.custitem_item_productcategory[0],
                    price: doc.values["pricing.unitprice"],
                    time: 0
                }).then(function(){
                    countItems ++
                    if (countItems === result.length) {
                        self.showProgress = false
                        self.snackbarColor = "success"
                        self.snackbarMessage = "Completed"
                        self.snackbar = true
                        self.fetchConfiguredServices()
                    }
                }).catch(function(error) {
                    console.error("Error cloning Netsuite document: ", error)
                    self.showProgress = false
                    self.snackbarColor = "error"
                    self.snackbarMessage = "Error cloning Netsuite document"
                    self.snackbar = true
                })
            }) 
        },

        syncAndUpdate(result) {
            let self = this
            let countItems = 0
            result.forEach(function(doc) {
                db.collection("Services"+self.$stage).doc(doc.values.itemid).update({
                    jobCode: doc.values.itemid,
                    name: doc.values.displayname,
                    description: doc.values.custitem_item_description[0],
                    classification: doc.values.custitem_item_industryclassification[0],
                    category: doc.values.custitem_item_productcategory[0],
                    price: doc.values["pricing.unitprice"],
                }).then(function(){
                    countItems ++
                    if (countItems === result.length) {
                        self.showProgress = false
                        self.snackbarColor = "success"
                        self.snackbarMessage = "Completed"
                        self.snackbar = true
                        self.fetchConfiguredServices()
                    }
                }).catch(function(error) {
                    console.error("Error syncing Netsuite document: ", error)
                    self.showProgress = false
                    self.snackbarColor = "error"
                    self.snackbarMessage = "rror syncing Netsuite document"
                    self.snackbar = true
                })
            }) 
        },

        async fetchConfiguredServices() {
            let self = this
            self.showProgress = true
            self.progressMessage = "Loading..."
            self.configuredServices = []
            await db.collection("Services"+self.$stage)
                .get().then(function(querySnapshots) {
                    querySnapshots.forEach(function(doc) {
                        self.configuredServices.push({
                            jobCode: doc.data().jobCode,
                            name: doc.data().name,
                            description: doc.data().description["text"],
                            displayName: doc.data().displayName,
                            displayDescription: doc.data().displayDescription,
                            classification: doc.data().classification["text"],
                            category: doc.data().category["text"],
                            price: doc.data().price,
                            time: doc.data().time,
                        })
                    })
                }).then(function(){
                    self.showProgress = false
                }).catch(function(error) {
                    console.error("Error fetching configured services: ", error)
                    self.showProgress = false
                    self.snackbarColor = "error"
                    self.snackbarMessage = "Error fetching configured services "
                    self.snackbar = true
                })
        },

        saveConfig(type,val,jobCode) {
            let self = this
            switch (type) {
                case "displayName":
                    db.collection("Services"+self.$stage).doc(jobCode).update({
                        displayName: val
                    })
                    break;
                case "displayDescription":
                    db.collection("Services"+self.$stage).doc(jobCode).update({
                        displayDescription: val
                    })
                    break;
                case "time":
                    db.collection("Services"+self.$stage).doc(jobCode).update({
                        time: Number(val)
                    })
                    break;
                default:
                    console.log(type);
            }
        },

        deployToBranch(service){
            let self = this
            self.showBranches = true
            self.selectedService = service
        },

        setBranchService() {
            let self = this
            let lists = []
            if (self.selectedBranches.businessUnit.length > 0) {
                self.showProgress = true
                self.progressMessage = "Loading..."
                self.selectedBranches.businessUnit.forEach(function(res) {
                    db.collection("ServiceGallery"+self.$stage).doc(res.branchCode)
                        .get().then(function(doc){
                            if (doc.exists) {
                                lists = doc.data().Service
                            }
                        }).then(function() {
                            if (lists.length > 0) {
                                lists.forEach(function(check){
                                    console.log(self.selectedService.jobCode)
                                    if (check.jobCode !== self.selectedService.jobCode) {
                                        lists.push(self.selectedService.jobCode)
                                    }
                                })
                                lists = _.uniqBy(lists);
                                db.collection("ServiceGallery"+self.$stage).doc(res.branchCode)
                                .update({
                                    Service: lists
                                }).then(function(){
                                    self.reload()
                                    self.showProgress = false
                                    self.showBranches = false
                                })
                            }  else {
                                db.collection("ServiceGallery"+self.$stage).doc(res.branchCode).set({
                                    Service: [self.selectedService.jobCode],
                                }).then(function(){
                                    self.reload()
                                    self.showProgress = false
                                    self.showBranches = false 
                                })
                            }
                        })
                })
            } else {
                self.snackbarColor = "error"
                self.snackbarMessage = "Please select a branch"
                self.snackbar = true
            }
        },

        reload() {
            window.location.reload()
        },

        toggleAll () {
            if (this.selectedBranches.businessUnit.length) selectedBranches.businessUnit = []
            else this.selectedBranches.businessUnit = this.activeBranches.slice()
        },
    },

    watch: {
 
    }

}
</script>

<style scoped>

</style>